import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, IconButton, ListItem, ListItemIcon, ListItemText, makeStyles, Menu, MenuItem, Typography } from '@material-ui/core'
import DashboardIcon from '@material-ui/icons/Dashboard';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import HistoryIcon from '@material-ui/icons/History';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AssessmentIcon from '@material-ui/icons/Assessment';
import EditIcon from '@material-ui/icons/Edit';
import HelpIcon from '@material-ui/icons/Help';
import {  NavLink, useHistory } from 'react-router-dom';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import PolicyIcon from '@material-ui/icons/Policy';
import pdfFilePolitica from "../../pdf/politica_de_proteccion_de_datos_personales.pdf";
import pdfFile from "../../pdf/manual.pdf";


import { COLORS_PROJECT } from '../../constants';
import { startLogut } from '../../actions/auth';


const {color_nav_letter}= COLORS_PROJECT;
const useStyles = makeStyles((theme) => ({
    icon: {
        color: color_nav_letter,
    },
    activeLink: {
        fontWeight: "bold",
        color: "blue",
    },
    size:{
        fontSize: 40,
    },
    spaceIcon:{
        marginLeft: theme.spacing(2)
    }
}));


export const MainListItems  = () => {

    const classes = useStyles()

    const [selectedIndex, setSelectedIndex] = useState()

    /**
     * Highlight the selected button
     * @param {Event} event 
     * @param {number} index 
     */
    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    }

    //validation for users
    const auth = useSelector(state => state.auth)
    console.log(auth.valitadion.tiemporeal)
    return (
        <div>
            
            
            {auth.valitadion.tiemporeal === 'True' &&
                (<ListItem button selected={selectedIndex === 0} onClick={(event) => handleListItemClick(event, 0)} component={NavLink} to="/tiempoReal" activeClassName={classes.activeLink}>
                <ListItemIcon className={classes.icon}>
                    <DashboardIcon />
                </ListItemIcon>
                
                <ListItemText primary="Tiempo Real" className={classes.icon}/>
            </ListItem>) 
            }

            {auth.valitadion.historic === 'True' &&
                (<ListItem button selected={selectedIndex === 1} onClick={(event) => handleListItemClick(event, 1)} component={NavLink} to="/historico" activeClassName={classes.activeLink}>
                    <ListItemIcon className={classes.icon} >
                        <HistoryIcon/>
                    </ListItemIcon>
                    
                    <ListItemText primary="Historico" className={classes.icon} />
                </ListItem>)
            }
            
            {auth.valitadion.report === 'True' &&
                (<ListItem button selected={selectedIndex === 2} onClick={(event) => handleListItemClick(event, 2)} component={NavLink} to="/report" activeClassName={classes.activeLink}>
                    <ListItemIcon className={classes.icon} >
                        <AssessmentIcon/>
                    </ListItemIcon>
                    
                    <ListItemText primary="Reporte" className={classes.icon} />
                </ListItem>)
            }

            {auth.valitadion.consrayos === 'True' &&
                (<ListItem button selected={selectedIndex === 1} onClick={(event) => handleListItemClick(event, 1)} component={NavLink} to="/rayos" activeClassName={classes.activeLink}>
                    <ListItemIcon className={classes.icon} >
                        <FlashOnIcon/>
                    </ListItemIcon>
                    
                    <ListItemText primary="Descarga rayos" className={classes.icon} />
                </ListItem>)
            }

            {auth.valitadion.crud === 'True' &&
                (<ListItem button selected={selectedIndex === 3} onClick={(event) => handleListItemClick(event, 3)} component={NavLink} to="/TWS" activeClassName={classes.activeLink}>
                    <ListItemIcon className={classes.icon} >
                        <EditIcon />
                    </ListItemIcon>

                    <ListItemText primary="TWS" className={classes.icon} />
                </ListItem>)
            }
            <ListItem button selected={selectedIndex === 4} onClick={() => window.open(pdfFile)} component={NavLink} to="/ayuda" activeClassName={classes.activeLink}>
                <ListItemIcon className={classes.icon}>
                    <HelpIcon />
                </ListItemIcon>
                
                <ListItemText primary="Ayuda" className={classes.icon}/>
            </ListItem>
            <ListItem button selected={selectedIndex === 4} onClick={() => window.open(pdfFilePolitica)} component={NavLink} to="/politica" activeClassName={classes.activeLink}>
                <ListItemIcon className={classes.icon}>
                    <PolicyIcon/>
                </ListItemIcon>
                
                <ListItemText primary="Tratamiento Datos" className={classes.icon}/>
            </ListItem>
           

            

        </div>
    )
    
}

export const MenuAccaunt = () =>{
    const classes = useStyles()
    const dispatch = useDispatch()

    const [anchorEl, setAnchorEl] = useState(null);
    const openAccaunt = Boolean(anchorEl);

    /**
     * To open Menu Account
     * @param {to prevent refresh} event 
     */
    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    /**
     * To close Menu
     */
    const handleClose = () => {
        setAnchorEl(null);
    };

    const history = useHistory();

    /**
     * Logout Account 
     */
    const handleLogout = () =>{
        dispatch(startLogut())
        history.push('/auth')
    }

    //responsive
    const {width}=useWindowDimensions();
    const [size, setSize] = useState(true)

    
    useEffect(() => {
        if(width <= 720){
            setSize(false)
        }else{
            setSize(true)
        }
        return size
    }, [size,width])


    const {name : userName} = useSelector(state => state.auth)

    return (

        <>
            {/* Profile */}
            {size &&
                <Typography component="h1" variant="h6" color="inherit">
                    {userName}
                </Typography>
            }


            <IconButton color="inherit" onClick={handleMenu} aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true">
                <AccountCircleIcon style={{ fontSize: 40 }} />
            </IconButton>

            {/* Menu account */}
            <Menu id="menu-appbar" anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={openAccaunt}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose}>
                    <AccountCircleIcon style={{ fontSize: 40 }} />
                    <Typography  variant="subtitle1" className={classes.spaceIcon}>{userName}</Typography>
                    
                </MenuItem>

                <Divider/>

                <MenuItem onClick={handleLogout}>
                        <ExitToAppIcon /> 
                        <Typography variant="subtitle1" className={classes.spaceIcon}> Salir</Typography>
                </MenuItem>

            </Menu>
        </>


    )
}


